export default "__VITE_ASSET__DFtdUmc7__"